/* eslint-disable @typescript-eslint/no-explicit-any */
export class UrlEncoder {
  static encode(obj: any): string {
    return btoa(encodeURIComponent(JSON.stringify(obj)));
  }

  static decode(encoded: string): any {
    if (!this.isBase64(encoded)) {
      throw new Error('Invalid base64 string provided to UrlEncoder.decode');
    }

    try {
      const decodedString = decodeURIComponent(atob(encoded));
      return JSON.parse(decodedString);
    } catch {
      throw new Error('Invalid encoded string provided to UrlEncoder.decode');
    }
  }

  private static isBase64(str: string): boolean {
    const base64Regex = /^[A-Za-z0-9+/=]+$/;
    return base64Regex.test(str);
  }
}
